<script setup lang="ts">
import useSitecoreStore from '@/stores/sitecore';
import type { RouteData } from '@sitecore-jss/sitecore-jss-vue';
import { Placeholder as ScPlaceholder } from '@sitecore-jss/sitecore-jss-vue';
import { storeToRefs } from 'pinia';
import { defineAsyncComponent } from 'vue';

defineProps<{
    route: RouteData;
}>();

const SvgSprites = defineAsyncComponent(() => import('./SvgSprites.vue'));
const sitecoreStore = useSitecoreStore();
const { pageEditing } = storeToRefs(sitecoreStore);
const show = import.meta.env.DEV || pageEditing;
</script>

<template>
    <div :class="{ 'with-exp-toolbar': pageEditing }">
        <ScPlaceholder
            name="product-pages-main"
            :rendering="route"
        />
        <SvgSprites v-if="show" />
    </div>
</template>
